var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"hover-tip",rawName:"v-hover-tip",value:(_vm.titleText),expression:"titleText"}]},[(_vm.logo)?_c('img',{staticStyle:{"height":"18px","width":"auto","vertical-align":"middle"},attrs:{"src":_vm.logo}}):(_vm.carrierName)?_c('md-icon',[_vm._v("sailing")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }